import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone, Mail } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/services', label: 'Services' },
    { path: '/pricing', label: 'Rates' },
    { path: '/reviews', label: 'Reviews' },
    { path: '/booking', label: 'Book Now' },
    { path: '/about', label: 'About' },
    { path: '/contact', label: 'Contact' }
  ];

  return (
    <header className="bg-black/95 backdrop-blur-sm text-white sticky top-0 z-50 border-b border-red-900/20">
      <div className="container mx-auto px-4">
        {/* Top bar with contact info */}
        <div className="hidden md:flex justify-end items-center gap-6 py-2 text-sm border-b border-red-900/20">
          <a href="tel:+12425258675" className="flex items-center gap-2 hover:text-red-500 transition-colors">
            <Phone className="w-4 h-4" />
            <span>+1242-525-8675</span>
          </a>
          <a href="mailto:rasrio777@hotmail.com" className="flex items-center gap-2 hover:text-red-500 transition-colors">
            <Mail className="w-4 h-4" />
            <span>rasrio777@hotmail.com</span>
          </a>
        </div>

        {/* Main navigation */}
        <div className="flex items-center justify-between py-4">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3">
            <img 
              src="https://customer-assets.emergentagent.com/job_c9569150-39ed-49a0-bcf7-6c91669fb705/artifacts/k5pmqpyw_IMG_8391%202.jpg" 
              alt="RELAX & RIDE Logo" 
              className="h-16 w-16 object-contain"
            />
            <div>
              <h1 className="text-2xl font-bold tracking-wider text-red-500">RELAX & RIDE</h1>
              <p className="text-xs text-gray-400">Premium Taxi Service</p>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`font-medium transition-colors hover:text-red-500 ${
                  isActive(link.path) ? 'text-red-500' : 'text-white'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          {/* CTA Button Desktop */}
          <Link to="/booking" className="hidden lg:block">
            <Button className="bg-red-600 hover:bg-red-700 text-white px-6 py-2">
              Book Now
            </Button>
          </Link>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden text-white p-2"
          >
            {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isMenuOpen && (
        <div className="lg:hidden bg-black border-t border-red-900/20">
          <nav className="container mx-auto px-4 py-4 flex flex-col gap-4">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsMenuOpen(false)}
                className={`font-medium transition-colors hover:text-red-500 py-2 ${
                  isActive(link.path) ? 'text-red-500' : 'text-white'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <div className="flex flex-col gap-2 pt-4 border-t border-red-900/20">
              <a href="tel:+12425258765" className="flex items-center gap-2 text-sm hover:text-red-500 transition-colors">
                <Phone className="w-4 h-4" />
                <span>+1242 525-8765</span>
              </a>
              <a href="mailto:RASRIO777@HOTMAIL.COM" className="flex items-center gap-2 text-sm hover:text-red-500 transition-colors">
                <Mail className="w-4 h-4" />
                <span>RASRIO777@HOTMAIL.COM</span>
              </a>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
